import { FaDrum } from "react-icons/fa6";
import { contactInfo } from "../../data/content";
import SocialIcons from "../ui/SocialIcons";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer
      className="animate-footerScroll bg-ink bg-repeat-x py-16 text-center text-stone-400"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/footer-bg.png)` }}
    >
      <div className="container">
        <a href="#accueil" className="mb-4 inline-flex items-center gap-2 text-white">
          <FaDrum className="text-gold-500" size={28} aria-hidden="true" />
          <span className="font-display text-2xl font-bold uppercase tracking-wide sm:text-3xl">
            Sham Dabke
          </span>
        </a>

        <SocialIcons variant="buttons" className="my-6 justify-center" />

        <p className="mb-1">
          Troupe de dabké &amp; percussions basée à Lyon – interventions dans toute la France et en
          Europe.
        </p>
        <p className="mb-1">
          Téléphone :{" "}
          <a href={`tel:${contactInfo.phoneHref}`} className="hover:text-gold-500">
            {contactInfo.phone}
          </a>{" "}
          – Email :{" "}
          <a href={`mailto:${contactInfo.email}`} className="hover:text-gold-500">
            {contactInfo.email}
          </a>
        </p>
        <p className="mt-4 text-sm">&copy; {year} Sham Dabke. Tous droits réservés.</p>
      </div>
    </footer>
  );
}
